import React from 'react';

const Error404 = () => (
  <div className="err-container text-center">
    <div className="err">
      <h1>404</h1>
      <h2>Sorry, page not found</h2>
    </div>

    <div className="err-body">
      <button>
        <a href="/options"> Go Back to Home Page </a>
      </button>
    </div>
  </div>
);

const Page = () => (
  <div className="page-err">
    <Error404 />
  </div>
);

export default Page;
